import * as React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { supabase } from "../../logic/client";

export default function EmailConfirmed(props: { handlePageChange: (page: string) => void }) {
  const [state, setState] = React.useState<"loading" | "ok" | "error">("loading");
  const hasRunRef = React.useRef(false);

  React.useEffect(() => {
    // Check if the confirmation check has already run once, there is no need for more
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const run = async () => {
      const token = new URLSearchParams(window.location.search).get("token");
      if (!token) {
        setState("error");
        return;
      }

      const { data, error } = await supabase.functions.invoke("confirm-email", {
        body: { token },
      });

      if (error || !data?.ok) {
        setState("error");
        return;
      }

      // Clean URL
      window.history.replaceState({}, "", "/email-confirmed");
      setState("ok");
    };

    run();
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 2 }}>
      <Paper sx={{ p: { xs: 3, sm: 4 }, textAlign: "center", width: "100%", maxWidth: 420 }}>
        {state === "loading" && <Typography>Bestätige E-Mail…</Typography>}

        {state === "ok" && (
          <>
            <Typography fontWeight={900}>E-Mail bestätigt 🎉</Typography>
            <Typography sx={{ mt: 1 }}>
              Sie können sich jetzt anmelden.
            </Typography>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => props.handlePageChange("Entry")}>
              Zur Anmeldung
            </Button>
          </>
        )}

        {state === "error" && (
          <>
            <Typography fontWeight={900} color="error">
              Bestätigung fehlgeschlagen
            </Typography>
            <Button sx={{ mt: 2 }} onClick={() => props.handlePageChange("Entry")}>
              Zur Anmeldung
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
